import { render, staticRenderFns } from "./RtcPrivateAcceptor.vue?vue&type=template&id=3ef3bc1e&scoped=true"
import script from "./RtcPrivateAcceptor.vue?vue&type=script&lang=js"
export * from "./RtcPrivateAcceptor.vue?vue&type=script&lang=js"
import style0 from "./RtcPrivateAcceptor.vue?vue&type=style&index=0&id=3ef3bc1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../Users/a0000/Documents/Box-IM/box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef3bc1e",
  null
  
)

export default component.exports